<template>
  <div>
    <div class="field">
      <label class="label">Service</label>
      <div class="control">
        <div class="select">
          <select v-model="service">
            <option value="">All Services</option>
            <option v-for="(service_row, index) in services_list" :key="index" :value="service_row.id" v-text="service_row.title"></option>
          </select>
        </div>
      </div>
    </div>
    <div class="field">
      <label class="label">Date</label>
      <div class="control">
        <input type="date" class="input" v-model="date">
      </div>
    </div>
    <div class="field is-grouped">
      <div class="control">
        <button type="button" class="button is-link" @click="getReport()">Submit</button>
        <button type="button" class="button is-warning" @click="getReportExport()">Download</button>
      </div>
    </div>
    <table class="table is-bordered is-fullwidth">
      <tr>
        <th class="has-text-centered" rowspan="3"></th>
        <th class="has-text-centered" colspan="3">Ticket Complimentary</th>
        <th class="has-text-centered" colspan="8">Ticket Penjualan</th>
      </tr>
      <tr>
        <th class="has-text-centered" rowspan="2">Awal</th>
        <th class="has-text-centered" rowspan="2">Diambil</th>
        <th class="has-text-centered" rowspan="2">Sisa</th>
        <th class="has-text-centered" rowspan="2">Awal</th>
        <th class="has-text-centered" colspan="2">BCA</th>
        <th class="has-text-centered" colspan="2">Maybank</th>
        <th class="has-text-centered" colspan="2"></th>
        <th class="has-text-centered" rowspan="2">Sisa</th>
      </tr>
      <tr>
        <th class="has-text-centered">Debit</th>
        <th class="has-text-centered">Credit</th>
        <th class="has-text-centered">Debit</th>
        <th class="has-text-centered">Credit</th>
        <th class="has-text-centered">Cash</th>
        <th class="has-text-centered">Total</th>
      </tr>
      <tr v-for="(data_row, index) in data_list" :key="index">
        <table-row v-for="(value_row, index_value) in data_row" :key="index_value" :value-row="value_row"></table-row>
      </tr>
    </table>
  </div>
</template>

<script>
import TableRow from '@/pages/panel/frontdesk/components/ReportRowEvent'
export default {
  data () {
    return {
      data_list: [],
      services_list: [],
      service: '',
      date: ''
    }
  },
  components: {
    TableRow
  },
  created () {
    this.getServices()
  },
  methods: {
    getServices () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyGet('new_people/get_services')
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          self.services_list = response.data.data
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    getReport () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyPostSession('report/event_cc', {
        service: this.service,
        date: this.date
      })
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          self.data_list = response.data.data
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    getReportExport () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyPostSession('report/export_event_cc', {
        service: this.service,
        date: this.date
      })
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          let link = document.createElement('a')
          link.href = response.data.data.file_url
          link.download = response.data.data.file_name
          link.click()
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/panel/frontdesk/report_event/CampusCoordinator.vue